import React, { memo } from "react";
import MapboxMap from "../common/MapboxMap";

function LocationMap({ locations, onLocationClick }) {
  const mapData = locations.map(loc => {
    // Count devices by type
    const mfrNodes = loc.devices?.filter(d => d.type === 'MFR Node').length || 0;
    const sapFlowMeters = loc.devices?.filter(d => d.type === 'Sap Flow Sensor').length || 0;
    const bandDendrometers = loc.devices?.filter(d => d.type === 'Band Dendrometer').length || 0;
    const wxt536Sensors = loc.devices?.filter(d => d.type === 'WXT536 Sensor').length || 0;
    const aqt530Sensors = loc.devices?.filter(d => d.type === 'AQT530 Sensor').length || 0;
    
    return {
      lat: loc.coordinates[0],
      lon: loc.coordinates[1],
      label: loc.name,
      abbrev: loc.name,
      locationName: loc.fullName,
      link: `/location/${loc.name}`,
      status: loc.status || 'no-data',
      lastSeen: loc.lastSeen,
      focus: 'Urban',
      city: loc.city,
      deviceCounts: {
        mfrNodes,
        sapFlowMeters,
        bandDendrometers,
        wxt536Sensors,
        aqt530Sensors
      }
    };
  });

  return (
    <div className="rounded-md overflow-hidden border mb-4">
      <MapboxMap 
        data={mapData} 
        height={350} 
        showLegend={false} 
        showDeviceDetails={false}
      />
    </div>
  );
}

// Memoize to prevent re-renders when parent re-renders
export default memo(LocationMap, (prevProps, nextProps) => {
  return prevProps.locations === nextProps.locations;
});